import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-image-slider',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule
  ],
  templateUrl: './image-slider.component.html',
  styleUrl: './image-slider.component.scss',
})
export class ImageSliderComponent implements OnInit {
  // slides variables having array of urls
  @Input() slides: string[] = [];
  // indivicator visibile
  @Input() indicatorsVisible = true;
  // animation speed
  @Input() animationSpeed = 500;
  // auto play flag
  @Input() autoPlay = false;
  // autoplay speed
  @Input() autoPlaySpeed = 3000;
  // initial slide
  currentSlide = 0;
  // hidden boolean flag
  hidden = false;

  next() {
    const currentSlide = (this.currentSlide + 1) % this.slides.length;
    this.jumpToSlide(currentSlide);
  }

  previous() {
    const currentSlide =
      (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.jumpToSlide(currentSlide);
  }

  jumpToSlide(index: number) {
    this.hidden = true;
    setTimeout(() => {
      this.currentSlide = index;
      this.hidden = false;
    }, this.animationSpeed);
  }

  ngOnInit() {
    if (this.autoPlay) {
      setInterval(() => {
        this.next();
      }, this.autoPlaySpeed);
    }
  }
}
